import React from 'react';
import PropTypes from 'prop-types';
import assignWith from 'lodash/fp/assignWith';
import getDisplayName from 'utils/getDisplayName';

const withThemes = (
  identifier,
  themes,
  composes = false,
) => (WrappedComponent) => {
  const ThemePicker = (props, context) => {
    const defaultTheme = themes.defaultTheme || {};
    const themeName = context.themes ? context.themes[identifier] : '';
    let contextTheme;
    let theme;

    if (props.useTheme) {
      contextTheme = themes[props.useTheme];
    } else if (context.themes && context.themes[identifier]) {
      contextTheme = themes[context.themes[identifier]];
    } else {
      contextTheme = false;
    }

    // Should theme styles override or compose the defaults?
    if (composes) {
      theme = assignWith(
        (objValue, srcValue) => ((objValue && srcValue) ? `${objValue} ${srcValue}` : (objValue || srcValue)),
        contextTheme,
        defaultTheme,
      );
    } else {
      theme = Object.assign({}, defaultTheme, contextTheme);
    }

    return (
      <WrappedComponent
        {...props}
        theme={theme}
        themeName={themeName}
      />
    );
  };

  ThemePicker.propTypes = {
    useTheme: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.bool,
    ]),
  };

  ThemePicker.defaultProps = {
    useTheme: false,
  };

  ThemePicker.contextTypes = {
    themes: PropTypes.object,
  };

  ThemePicker.displayName = getDisplayName('ThemePicker', WrappedComponent);

  return ThemePicker;
};

export default withThemes;
